export const chunkSymbols = (symbols, chunkSize) => {
  if (!Number.isInteger(chunkSize) || chunkSize < 1) {
    throw new RangeError('chunkSize must be a positive integer');
  }

  const chunks = [];
  for (let index = 0; index < symbols.length; index += chunkSize) {
    chunks.push(symbols.slice(index, index + chunkSize));
  }
  return chunks;
};

export const runBatchesWithConcurrency = async (
  batches,
  concurrency,
  runBatch,
  onBatchComplete
) => {
  if (!Number.isInteger(concurrency) || concurrency < 1) {
    throw new RangeError('concurrency must be a positive integer');
  }

  const results = new Array(batches.length);
  let nextBatchIndex = 0;
  let firstError;
  let hasError = false;

  const runWorker = async () => {
    while (!hasError) {
      const batchIndex = nextBatchIndex;
      nextBatchIndex += 1;
      if (batchIndex >= batches.length) return;

      const batch = batches[batchIndex];
      try {
        const result = await runBatch(batch);
        results[batchIndex] = result;
        onBatchComplete(result, batch);
      } catch (error) {
        if (!hasError) {
          firstError = error;
          hasError = true;
        }
        return;
      }
    }
  };

  const workerCount = Math.min(concurrency, batches.length);
  await Promise.all(Array.from({ length: workerCount }, runWorker));
  if (hasError) throw firstError;

  return results;
};
